import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import { SetState } from "source/app/services/UI/State/SetState";
import { IBookOfMindState } from "./IBookOfMindState";

export function SetBookOfMindState(newState: Partial<IBookOfMindState>) {
    SetState<IBookOfMindState>(ESharedFunction.BookOfMind, newState);
}
